import apiService from '@/api/request';
import {
  PAYTYPE,
  WITHDRAWTYPE,
  FITLABELLIST,
} from '../mutation-type';

// eslint-disable-next-line import/prefer-default-export
export const getPayType = async ({ commit, state }) => {
  console.log('getPayType:', getPayType);
  if (!state.user.userToken) return;
  const res = await apiService.GetPayType({
    userToken: state.user.userToken,
  });
  if (res.status === 1) {
    commit(PAYTYPE, res.data);
  }
};

export const getWithdrawType = async ({ commit, state }) => {
  if (!state.user.userToken) return;
  const res = await apiService.GetWithdrawType({
    userToken: state.user.userToken,
  });
  if (res.status === 1) {
    commit(WITHDRAWTYPE, res.data);
  }
};

export const getFitList = async ({ commit, state }) => {
  if (!state.user.userToken) return;
  const res = await apiService.GetRechargeRange({
    userToken: state.user.userToken,
  });
  if (res.status === 1) {
    commit(FITLABELLIST, res.data.range);
  }
};
